<ng-container
  [brManageMenuButton]="menu"
  *ngIf="page.isPreview()"
></ng-container>
<div *ngIf="isLoggedIn" edsGrid [edsSpacing]="marginBottom">
  <div edsgrid>
    <div [class]="container">
      <div edsSubGrid="layout-1" edsSubGridGap="md" edsSubGridRowGap="md">
        <!-- My Favourite Funds -->
        <div
          *ngIf="showFavFundCard"
          [class.my-dashboard--grey]="background === 'grey'"
        >
          <eds-card-dashboard
            [card]="favFundsCard"
            [fullHeight]="true"
            (menuItemSelectedWithIndexOutput)="selectedIndex($event)"
            (btnSubscribe)="openPPSSPage($event)"
          >
            <eds-card-dashboard-favorite-funds
              [tableProperties]="favFundsTableProperties"
              [favoriteFundData]="favFunds"
              (btnRemoveFund)="removeFavFunds($event)"
              [rightAlignLink]="true"
              [enableScrolling]="true"
            ></eds-card-dashboard-favorite-funds>
          </eds-card-dashboard>
        </div>

        <!-- My Literature -->
        <div
          *ngIf="showLiteratureCard"
          [class.my-dashboard--grey]="background === 'grey'"
        >
          <!-- Reuse Shared Cart Modal -->
          <ft-literature-dialog
            [dialogId]="ModalId['Cart_Modal']"
            [modalIdEnum]="modalId"
            (dialog)="closeDialog(modalId)"
            (deleteCartDoc)="deleteFromCart($event)"
            [gridData]="dialogData"
          ></ft-literature-dialog>

          <eds-card-dashboard
            [card]="literatureCard"
            [fullHeight]="true"
            (btnSubscribe)="openHistoryPage($event)"
          >
            <eds-card-dashboard-literature
              [literatureTableProperties]="literatureTableProperties"
              [toggleButtons]="toggleButtons"
              [documentData]="literatureDocumentData"
              (btnAddToCart)="addToCart($event)"
              (btnDownloadDocument)="downloadDocument($event)"
              [enableScrolling]="true"
            ></eds-card-dashboard-literature>
          </eds-card-dashboard>
        </div>

        <!-- My Saved Hypotheticals -->
        <div
          *ngIf="
            showSavedHypotheticals ||
            (parameters.showSavedHypotheticals && page.isPreview())
          "
          [class.my-dashboard--grey]="background === 'grey'"
        >
          <eds-card-dashboard
            [card]="savedHypotheticalsCard"
            [fullHeight]="true"
            [isNewWindow]="true"
            [externalLink]="true"
            externalSuffix="leaving-tools"
          >
            <eds-card-dashboard-saved-hypotheticals
              [hypotheticalTableProperties]="hypotheticalTableProperties"
              [hypotheticalsData]="visibleHypotheticalsData"
              [isNewWindow]="true"
              [externalLink]="true"
              externalSuffix="leaving-tools"
              [enableScrolling]="true"
            >
            </eds-card-dashboard-saved-hypotheticals>
          </eds-card-dashboard>
        </div>
        <!-- My Sales Team Contacts -->
        <div
          *ngIf="
            showSalesTeamCard || (parameters.salesTeams && page.isPreview())
          "
          [class.my-dashboard--grey]="background === 'grey'"
        >
          <eds-card-dashboard
            (btnSubscribe)="bookPhoneConsultation($event)"
            [card]="salesTeamCard"
            [fullHeight]="true"
          >
            <eds-avatar
              *ngFor="let salesTeam of salesTeamList"
              [title]="salesTeam.firstName + ' ' + salesTeam.lastName"
              [text1]="salesTeam.role"
              [text2]="salesTeam.telephone"
              [imgSrc]="salesTeam.profileImage"
              fallbackImgSrc="/assets/images/ben_head.png"
              edsSpacing="lg"
            >
            </eds-avatar>
          </eds-card-dashboard>
        </div>
      </div>
    </div>
  </div>
</div>
